import React from 'react';
import { Search } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * FilterInput - A themed search input component for admin filters
 * Uses the filters.backgroundColor from ThemeContext for consistent styling
 */
const FilterInput = ({ 
  value, 
  onChange, 
  placeholder = 'Search...',
  icon: Icon = Search,
  showIcon = true,
  className = '',
  'data-testid': testId,
  ...props 
}) => {
  const { adminTheme } = useTheme();
  const filterBgColor = adminTheme?.filters?.backgroundColor || '#D4F6FF';

  return (
    <div className={`relative ${className}`}>
      {showIcon && (
        <Icon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
      )}
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`w-full ${showIcon ? 'pl-10' : 'pl-4'} pr-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2`}
        style={{ backgroundColor: filterBgColor }}
        data-testid={testId}
        {...props}
      />
    </div>
  );
};

export default FilterInput;
